import PropTypes from 'prop-types'

import CoverHighlight from 'components/CoverHighlight'

function HighlightBlock({ highlight = {} }) {
  const linkedHighlight = highlight?.nodes?.[0]
  if (!linkedHighlight) return null

  return <CoverHighlight cover={linkedHighlight} />
}

HighlightBlock.propTypes = {
  highlight: PropTypes.object,
}

export default HighlightBlock
